import { AxiosError } from 'axios'
import toastify from '../../components/Toastify'

const toastDelay = 10000
let errorTimer: NodeJS.Timeout | null = null

const majorRequestPrefixes = ['/market', '/trading']
export function handleError(err: AxiosError) {
  const { config } = err
  const { url } = config

  console.error(err)
  console.log(url)
  // If the request is a major interface, the error message is displayed directly.
  if (majorRequestPrefixes.some((v) => url?.startsWith(v))) {
    displayError(err)
  } else {
    if (!errorTimer) {
      errorTimer = setTimeout(() => {
        errorTimer = null
      }, toastDelay)
    } else {
      clearTimeout(errorTimer)
      errorTimer = null
      displayError(err)
    }
  }
}

export function displayError(err: AxiosError) {
  const { config, message, response } = err
  const { url } = config
  const { status } = response ?? {}

  const uniqueId = String(status) ?? err.code

  const maxUrlLength = 30
  const displayUrl =
    url && url?.length > maxUrlLength
      ? `${url?.slice(0, maxUrlLength)}...`
      : url
  // toastify.error(
  //   `Network error. Consider refreshing the page or checking your connection. Error: ${message}, ${displayUrl}`,
  //   {
  //     id: uniqueId,
  //   },
  // )
}
